/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
var textOS = "Only 1 left";
$(window).on("load", function() {
  	var tm = $(t).attr("qtyrumpus");
    $(".last-in-stock-rumpus").hide();
    $(".last-in-stock-rumpus-bundle-top").hide();
    $(".last-in-stock-rumpus-bundle-bottom").hide();
    if (tm === 1) {
      $(".last-in-stock-rumpus").show();
      $(".last-in-stock-rumpus-bundle-top").show();
      $(".last-in-stock-rumpus-bundle-bottom").show();
    }
    var t = $(".SizeSwatch__Radio:checked+.SizeSwatch.itsrumpuslabel");
    setTimeout(function() {
        1 == $(t).attr("qtyrumpus") && $(".last-in-stock-rumpus").text(textOS)
    }, 100);
  
    var u = $(".SizeSwatch__Radio:checked+.SizeSwatch.toprumpusinven");
    setTimeout(function() {
        1 == $(u).attr("qtyrumpus") && $(".last-in-stock-rumpus-bundle-top").text(textOS)
    }, 100);
  
    var s = $(".SizeSwatch__Radio:checked+.SizeSwatch.bottomrumpusinven");
    setTimeout(function() {
        1 == $(s).attr("qtyrumpus") && $(".last-in-stock-rumpus-bundle-bottom").text(textOS)
    }, 100)
})
$(".itsrumpuslabel").click(function(t) {
    var u = this;
  var tm = $(u).attr("qtyrumpus");
    $(".last-in-stock-rumpus").hide();
    $(".last-in-stock-rumpus-bundle-top").hide();
    $(".last-in-stock-rumpus-bundle-bottom").hide();
    if (tm === 1) {
      $(".last-in-stock-rumpus").show();
    }
    setTimeout(function() {
        1 == $(u).attr("qtyrumpus") ? $(".last-in-stock-rumpus").html(textOS) : $(".last-in-stock-rumpus").html("&nbsp;")
    }, 100)
})
$(".bottomrumpusinven").click(function(t) {
    var u = this;
  var tm = $(u).attr("qtyrumpus");
    $(".last-in-stock-rumpus").hide();
    $(".last-in-stock-rumpus-bundle-top").hide();
    $(".last-in-stock-rumpus-bundle-bottom").hide();
    if (tm === 1) {
      $(".last-in-stock-rumpus-bundle-bottom").show();
    }
    setTimeout(function() {
        1 == $(u).attr("qtyrumpus") ? $(".last-in-stock-rumpus-bundle-bottom").html(textOS) : $(".last-in-stock-rumpus-bundle-bottom").html("&nbsp;")
    }, 100)
})
$(".toprumpusinven").click(function(t) {
    var u = this;
    var tm = $(u).attr("qtyrumpus");
    $(".last-in-stock-rumpus").hide();
    $(".last-in-stock-rumpus-bundle-top").hide();
    $(".last-in-stock-rumpus-bundle-bottom").hide();
    if (tm === 1) {
      $(".last-in-stock-rumpus-bundle-top").show();
    }
    setTimeout(function() {
        1 == $(u).attr("qtyrumpus") ? $(".last-in-stock-rumpus-bundle-top").html(textOS) : $(".last-in-stock-rumpus-bundle-top").html("&nbsp;")
    }, 100)
});